/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, Button} from 'eui-components';
import {FormattedMessage} from 'react-intl';


/**
 * Modal displayed when the user attempts to navigate away from a dirty form.
 */
class DirtyFormConfirmation extends Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  };

  constructor (props) {
    super(props);
    this.state = {show: true};
  }

  handleClose = () => {
    this.setState({show: false});
  };

  cancel = (e) => {
    this.handleClose();
    this.props.onCancel();
  };

  confirm = (e) => {
    this.handleClose();
    this.props.onConfirm();
  };

  render () {
    return (
      <Modal show={this.state.show} backdrop='static' keyboard={false} onHide={this.handleClose}>
        <Modal.Header>
          <Modal.Title><FormattedMessage id='DirtyFormConfirmation.modalTitle' defaultMessage='Confirm' /></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <FormattedMessage id='DirtyFormConfirmation.bodyMessage'
              defaultMessage={'Are you sure you want to leave this page without saving your changes? ' +
              'If you continue without saving, all changes you\'ve made since you last saved will be lost.'}
            />
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.cancel} bsStyle='primary'>
            <FormattedMessage id='DirtyFormConfirmation.cancelNavigation' defaultMessage='Cancel' />
          </Button>
          <Button onClick={this.confirm}>
            <FormattedMessage id='DirtyFormConfirmation.okNavigation' defaultMessage='OK' />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DirtyFormConfirmation;



// WEBPACK FOOTER //
// ./src/DomainApplicationView/DirtyFormConfirmation.js